// Shared utilities for CRM components
import axios from 'axios';

import api from '../../lib/axios';
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const getAuthHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('nautilus_token')}` }
});

export const formatCurrency = (val) => {
  if (!val && val !== 0) return 'R$ 0,00';
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val);
};

export const formatDate = (d) => {
  if (!d) return '-';
  try { return new Date(d).toLocaleDateString('pt-BR'); } catch { return '-'; }
};

export const quillModules = {
  toolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']]
};
export const quillFormats = ['bold', 'italic', 'underline', 'list'];
